import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

const Container = styled.div`
    display: flex;
    flex-flow: column wrap;
    width: 100%;
    position: relative;
    margin-top: 30px;
    ${({ theme }) => css`
        ${theme.breakpoints.from.medium.css`
         flex-direction: unset;
      `}
    `}
`;

const ShapeImgWithSubBar = ({ children }) => {
    return <Container>{children}</Container>;
};

ShapeImgWithSubBar.ButtonContainer = styled.div`
    position: absolute;
    top: 10px;
    z-index: 4;
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => css`
        ${theme.breakpoints.from.medium.css`
         top: 0;
      `}
    `}
`;
ShapeImgWithSubBar.ButtonContainer.displayName =
    "ShapeImgWithSubBar.ButtonContainer";

ShapeImgWithSubBar.LeftContainer = styled.div`
    order: 2;
    background-color: ${({ theme }) => theme.colors.red.toString()};
    width: 100%;
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}
    ${({ theme }) => css`
        ${theme.breakpoints.from.medium.css`
          order: 1;
          width: 50%;
          padding-right: 0;
          margin-top: 20px;
          background-color: unset;
      `}
    `}
`;
ShapeImgWithSubBar.LeftContainer.displayName =
    "ShapeImgWithSubBar.LeftContainer";

ShapeImgWithSubBar.SubBar = styled.div`
    width: 100%;
    margin-top: 0;
    order: 3;
    ${({ theme }) => css`
        ${theme.breakpoints.from.medium.css`
          margin-top: 80px;
      `}
    `}
`;
ShapeImgWithSubBar.SubBar.displayName = "ShapeImgWithSubBar.SubBar";

ShapeImgWithSubBar.RightContainer = styled.div`
    width: 100%;
    position: relative;
    order: 1;
    height: 200px;
    ${({ theme }) => css`
        ${theme.breakpoints.from.medium.css`
          display: flex;
          order: 2;
          width: 50%;
          height: 400px;
      `}
    `}
`;
ShapeImgWithSubBar.RightContainer.displayName =
    "ShapeImgWithSubBar.RightContainer";

ShapeImgWithSubBar.ImgFilter = styled.div`
    position: absolute;
    top: 0;
    bottom: ${(props) =>
        props.filterBottomPostion ? props.filterBottomPostion : 0};
    left: 0;
    z-index: 1;

    svg {
        width: auto;
        height: 100%;
    }
`;
ShapeImgWithSubBar.ImgFilter.displayName = "ShapeImgWithSubBar.ImgFilter";

export default ShapeImgWithSubBar;
